module.exports = __webpack_public_path__ + "static/surely-youre-joking-mr-feynman-432f3bad273cd3430e44c3765487a830.jpg";